const geocode = async (placesData) => {
  try {
    const storedKey = localStorage.getItem('google_geocode_key');
    const googleKey = storedKey || process.env.REACT_APP_GEOCODE_KEY;

    // Step 1: Initiate the geocoding job
    const response = await fetch('https://geocode.afi.io/api/v1/geocode', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        google_key: googleKey,
        places: placesData,
      }),
    });

    const { id: jobId } = await response.json();

    // Step 2: Poll the API until the status is "finished"
    const pollGeocodeJob = async (jobId) => {
      const checkStatus = async () => {
        const response = await fetch(`https://geocode.afi.io/api/v1/geocode/${jobId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        if (data.status === 'finished') {
          return data; // Return the final data when finished
        } else {
          // Continue polling after 1 second if the job is not finished
          return new Promise((resolve) => {
            setTimeout(async () => {
              resolve(await checkStatus());
            }, 1000);
          });
        }
      };

      return await checkStatus();
    };

    // Step 3: Get the final geocoded data
    const { places } = await pollGeocodeJob(jobId);

    // Handle the final geocoded data
    console.log('Geocoding completed:', places);
    return places;
  } catch (error) {
    console.error('Error during geocoding:', error);
    throw error; // Re-throw the error to handle it upstream if needed
  }
};

export default geocode;
